const init = (text, option) => {
    var forceBreak;
    if (option == "itsTranscript") {
        forceBreak = text.replace(/\/n/g, '');
    }
    else {
        forceBreak = text.replace(/\/n/g, '<br>');
    }
    return forceBreak
}
export default {
    init
};

